import { Injectable, signal, computed, effect, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ProductModel } from '../models/product.model';

type QuoteItem = { product: ProductModel; notes?: string };

@Injectable({ providedIn: 'root' })
export class QuoteService {
  private readonly KEY = 'quote.v1';

  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  private itemsSig = signal<QuoteItem[]>(this.load());
  items = computed(() => this.itemsSig());

  constructor() {
    if (this.isBrowser) {
      effect(() => {
        try {
          localStorage.setItem(this.KEY, JSON.stringify(this.itemsSig()));
        } catch {}
      });
    }
  }

  add(p: ProductModel) {
    const exists = this.itemsSig().some(x => x.product.id === p.id);
    if (!exists) this.itemsSig.set([...this.itemsSig(), { product: p }]);
  }

  remove(id: string) { this.itemsSig.set(this.itemsSig().filter(x => x.product.id !== id)); }
  clear() { this.itemsSig.set([]); }

  private load(): QuoteItem[] {
    if (!this.isBrowser) return [];
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); }
    catch { return []; }
  }
}
